<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <v-card class="pa-6" elevation="0" color="transparent">
          <v-icon size="120" color="primary" class="mb-4 animate-bounce">mdi-rocket-launch</v-icon>
          
          <h1 class="text-h2 font-weight-bold mb-4 primary--text">Coming Soon</h1>
          
          <p class="text-h5 grey--text text--darken-1 mb-8">
            We're working on something awesome! Our support system is being enhanced to serve you better.
          </p>
          
          <v-chip class="ma-2" color="primary" outlined large>
            <v-icon left>mdi-clock-outline</v-icon>
            Launch Date: Coming Soon
          </v-chip>
          
          <v-card-text class="mt-8">
            <div class="text-subtitle-1 grey--text text--darken-2">
              In the meantime, you can reach us at:
            </div>
            <v-btn text color="primary" class="mt-2">
              <v-icon left>mdi-email</v-icon>
              support@nsuk.edu.ng
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SupportPage'
}
</script>

<style scoped>
.animate-bounce {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
</style>